import { createContext, useContext, useMemo, useState } from 'react';

interface LoadingState {
  labs: boolean;
  labsCount: number;
  patients: boolean;
  tests: boolean;
  biomarkers: boolean;
  providers: boolean;
}

interface LoadingContextType {
  loadingState: LoadingState;
  setLoadingState: React.Dispatch<React.SetStateAction<LoadingState>>;
}

export const LoadingContext = createContext<LoadingContextType | null>(null);

export const useLoadingContext = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoadingContext must be used within a LoadingFormProvider');
  }
  return context;
};

export const LoadingFormProvider = ({ children }) => {
  const [loadingState, setLoadingState] = useState({
    labs: false,
    labsCount: 0,
    patients: false,
    tests: false,
    biomarkers: false,
    providers: false,
  });

  const value = useMemo(() => {
    return { loadingState, setLoadingState };
  }, [loadingState]);
  return <LoadingContext.Provider value={value}>{children}</LoadingContext.Provider>;
};
